import type { TEmailBuilderReferencedMediaMap } from "api/rpc/2024-04/facilityAdmin/marketing/emailBuilderTypes";
import {
  registerEmailBuilderLibraryMediaSource,
} from "./media";
import type { EmailDocument } from "./types";

export type EmailDocumentLoadContext = {
  referencedMedia: TEmailBuilderReferencedMediaMap;
};

function registerReferencedMediaSources(
  referencedMedia: TEmailBuilderReferencedMediaMap,
): void {
  for (const mediaId in referencedMedia) {
    if (!Object.prototype.hasOwnProperty.call(referencedMedia, mediaId)) {
      continue;
    }
    registerEmailBuilderLibraryMediaSource(
      mediaId,
      referencedMedia[mediaId].source,
    );
  }
}

export function enrichEmailDocumentFromLoadContext(
  document: EmailDocument,
  context: EmailDocumentLoadContext,
): EmailDocument {
  registerReferencedMediaSources(context.referencedMedia ?? {});
  return document;
}
